import React from "react";
const DataContext = React.createContext({
        bills:[],
        currentBill:null,
        loading:false,
        handleBills:()=>{},
        handleCurrentBill:()=>{},
        handleLoading:()=>{},
        handleToken:()=>{},
        token:null,
        error:null,
        handleError:()=>{}
});
export default DataContext;